




























import { mapActions } from 'vuex';
import { Component, Vue, Watch } from 'vue-property-decorator';
import '@/types';
import cCard from '@/components/default/Card.vue';

import notificationService from '@/services/notificationService';
import Company from '@/classes/CRM/Company';
import CompanyDetailsCard from '@/components/crm/company/CompanyDetailsCard.vue';
import CompanyEmployeeCard from '@/components/crm/company/CompanyEmployeesCard.vue';
import ContactPricingAgreementCard from '@/components/crm/shared/ContactPricingAgreementCard.vue';

import projectOverviewCard from '@/components/projects/projectsOverviewCard.vue';
import BillingDetailsCard from '@/components/crm/shared/BillingDetailsCard.vue';

@Component({
  components: {
    cCard,
    CompanyDetailsCard,
    CompanyEmployeeCard,
    ContactPricingAgreementCard,
    projectOverviewCard,
    BillingDetailsCard,
  },
})
export default class SubcontractorDetails extends Vue {
  initialising: boolean = true;
  company: Company = new Company();

  async addOrUpdateAddress(address: IAddress, index: number) {
    const success = await this.company.addOrUpdateAddress(address, index);
    if (success) {
      (this.$refs.CompanyDetailsCard as CompanyDetailsCard).showEditAddressModal = false;
    }
  }
  async deleteAddress(index: number) {
    await this.company.deleteAddress(index);
    (this.$refs.CompanyDetailsCard as CompanyDetailsCard).showRemoveAddressModal = false;
  }

  private async mounted() {
    this.initialising = true;
    await this.company.loadData(this.$route.params.id);
    this.initialising = false;
  }

  async reload() {
    this.initialising = true;
    await this.company.loadData(this.$route.params.id);
    this.initialising = false;
  }

  get routeId() {
    return this.$route.params.id;
  }
}
